// src/lib/telemetry/storage.ts
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

export async function uploadScreenshot(blob: Blob) {
  const storage = getStorage();
  const uid = getAuth().currentUser?.uid ?? 'anon';
  const ts = Date.now();
  const path = `screenshots/${ts}_${uid}.png`;
  const fileRef = ref(storage, path);
  await uploadBytes(fileRef, blob, { contentType: 'image/png' });
  return await getDownloadURL(fileRef);
}
